import { render, staticRenderFns } from "./SearchSortingDropdown.vue?vue&type=template&id=697499dc&scoped=true&"
import script from "./SearchSortingDropdown.vue?vue&type=script&lang=ts&"
export * from "./SearchSortingDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SearchSortingDropdown.vue?vue&type=style&index=0&id=697499dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697499dc",
  null
  
)

export default component.exports